import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { normalizeRichHtmlForDisplay } from '../shared/utils/rich-html-sanitizer.util';

@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    if (!value) {
      return '';
    }

    const normalized = normalizeRichHtmlForDisplay(value);
    const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, normalized) || '';

    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }
}
